import React from 'react'

export function RequiredIndicator() {
	return <span className="ml-1 text-red-500">*</span>
}
